import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { snakeCaseToTitleCase } from '~/lib/cases';
import { useDocumentsView } from '../../provider';
const capitalizeAcronyms = {
    'Sic Code': 'SIC Code',
    'Naics Code': 'NAICS Code',
    'Fein Code': 'FEIN Code',
    'Ern Number': 'ERN Number',
};
const DecPageElement = ({ decPageKey }) => {
    const { anchorDoc, comparatorDoc, selectedElement, setSelectedElement, anchorBookmark, setAnchorBookmark, comparatorBookmark, setComparatorBookmark, } = useDocumentsView();
    const [anchorDecPageItems, setAnchorDecPageItem] = useState([]);
    const [compDecPageItems, setCompDecPageItem] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);
    const [selectedAnchorIndex, setSelectedAnchorIndex] = useState(0);
    const [selectedComparatorIndex, setSelectedComparatorIndex] = useState(0);
    const isSelected = selectedElement.length === 2 &&
        selectedElement[0] === 'dec-page' && selectedElement[1] === decPageKey;
    useEffect(() => {
        if (!anchorDoc || !comparatorDoc)
            return;
        setAnchorDecPageItem(anchorDoc.data.decPageFields[decPageKey] || []);
        setCompDecPageItem(comparatorDoc.data.decPageFields[decPageKey] || []);
    }, [decPageKey, anchorDoc, comparatorDoc]);
    useEffect(() => {
        if (isSelected) {
            const anchorFieldItem = anchorDecPageItems[selectedAnchorIndex];
            if (anchorFieldItem && anchorFieldItem.pageNumber && anchorFieldItem.coordinates) {
                setAnchorBookmark([{ annotations: [{
                                pageNum: Number(anchorFieldItem.pageNumber),
                                coordinates: anchorFieldItem.coordinates,
                                confidenceScore: anchorFieldItem.confidenceScore,
                            }] }]);
            }
            else {
                setAnchorBookmark([]);
            }
            const compFieldItem = compDecPageItems[selectedComparatorIndex];
            if (compFieldItem && compFieldItem.pageNumber && compFieldItem.coordinates) {
                setComparatorBookmark([{ annotations: [{
                                pageNum: Number(compFieldItem.pageNumber),
                                coordinates: compFieldItem.coordinates,
                                confidenceScore: compFieldItem.confidenceScore,
                            }] }]);
            }
            else {
                setAnchorBookmark([]);
            }
        }
        else if (selectedElement[1] === `clear-${decPageKey}` && (anchorBookmark.length || comparatorBookmark.length)) {
            setAnchorBookmark([]);
            setComparatorBookmark([]);
        }
    }, [isSelected, selectedAnchorIndex, selectedComparatorIndex]);
    const buildBody = () => {
        var _a;
        const elementOptionsClass = classnames('element-nav-options', {
            expanded: isExpanded,
        });
        const descriptor = snakeCaseToTitleCase(decPageKey);
        return React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'element-name-row' },
                React.createElement("div", { className: 'overflow-ellipsis' }, (_a = capitalizeAcronyms[descriptor]) !== null && _a !== void 0 ? _a : descriptor.replaceAll('100 Pct ', '')),
                React.createElement("span", { className: 'icons' },
                    compDecPageItems && compDecPageItems.some(c => c.coordinates && c.pageNumber) &&
                        React.createElement("span", null,
                            React.createElement("i", { className: 'fas fa-file' })),
                    anchorDecPageItems && anchorDecPageItems.some(c => c.coordinates && c.pageNumber) &&
                        React.createElement("span", null,
                            React.createElement("i", { className: 'fas fa-star' })))),
            React.createElement("div", { className: elementOptionsClass }, isExpanded && React.createElement(React.Fragment, null,
                !!(anchorDecPageItems.length) && React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'icon-anchor' },
                        React.createElement("i", { className: 'fas fa-star' })),
                    React.createElement("div", { className: 'document-options' }, anchorDecPageItems.map((decPageItem, index) => {
                        const isOptionSelected = index === selectedAnchorIndex;
                        const optionContainerClass = classnames('option-container', {
                            selected: isSelected && isOptionSelected,
                        });
                        return React.createElement("div", { className: optionContainerClass, onClick: e => {
                                setSelectedAnchorIndex(index);
                                if (!isSelected)
                                    setSelectedElement(['dec-page', decPageKey]);
                                e.stopPropagation();
                            } },
                            decPageItem.subkey || '',
                            "\u00A0Page ",
                            decPageItem.pageNumber);
                    }))),
                !!(compDecPageItems.length) && React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'icon-compare' },
                        React.createElement("i", { className: 'fas fa-file' })),
                    React.createElement("div", { className: 'document-options' }, compDecPageItems.map((decPageItem, index) => {
                        const isOptionSelected = index === selectedComparatorIndex;
                        const optionContainerClass = classnames('option-container', {
                            selected: isSelected && isOptionSelected,
                        });
                        return React.createElement("div", { className: optionContainerClass, onClick: e => {
                                setSelectedComparatorIndex(index);
                                if (!isSelected)
                                    setSelectedElement(['dec-page', decPageKey]);
                                e.stopPropagation();
                            } },
                            decPageItem.subkey || '',
                            "\u00A0Page ",
                            decPageItem.pageNumber);
                    }))))));
    };
    const hasNavigation = (anchorDecPageItems.length && anchorDecPageItems.some(c => c.coordinates && c.pageNumber)) || (compDecPageItems.length && compDecPageItems.some(c => c.coordinates && c.pageNumber));
    const deClass = classnames('data-element dec-page', {
        'has-navigation': hasNavigation,
        'selected': isSelected,
    });
    const dataElementSelection = () => {
        if (!hasNavigation)
            return;
        if (isExpanded) {
            setIsExpanded(false);
            if (isSelected)
                setSelectedElement(['dec-page', `clear-${decPageKey}`]);
        }
        else {
            setSelectedElement(['dec-page', decPageKey]);
            setIsExpanded(true);
        }
    };
    return React.createElement("div", { className: deClass, onClick: dataElementSelection },
        React.createElement("div", { className: 'category-row' },
            React.createElement("div", { className: 'category-title' }, "Dec Page Field"),
            hasNavigation &&
                React.createElement("div", { className: 'toggle-icons', key: `${decPageKey}-${isExpanded}` },
                    React.createElement("i", { className: !isExpanded ? 'fal fa-angle-up' : 'fal fa-angle-down' }))),
        buildBody());
};
export default DecPageElement;
